import { z } from "zod";
import {
  ClientSegment,
  Currency,
  FacilitySegment,
  MonthlyFee,
} from "./common.schema.js";

export const Organisation = z.object({
  businessName: z.string().min(1),
  shortName: z.string().min(1).nullable(),
  awrsRegistrationNumber: z.string().min(1).nullable(),
  d2cFulfilmentFee: z.string(),
  masterAgreementSignedDates: z.array(z.string()),
  currency: Currency,
  clientSegment: ClientSegment,
  facilitySegment: FacilitySegment,
  nominatedPurchaserFee: z.string().nullable(),
  defaultMonthlyFee: MonthlyFee.nullable(),
  defaultThroughputFee: z.string().nullable(),
  logoUrl: z.string().nullable(),
  contactEmail: z.string().nullable(),
  accountsEmails: z.array(z.string()),
  defaultFeroFxServiceCharge: z.string(),
  vatNumber: z.string().min(1).nullable(),
  crnNumber: z.string().min(1).nullable(),
  wowgrNumber: z.string().min(1).nullable(),
});

export type Organisation = z.infer<typeof Organisation>;
